var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34722",
    "data-name": "Group 34722",
    transform: "translate(14537 1198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9491",
    "data-name": "Rectangle 9491",
    width: 30,
    height: 30,
    transform: "translate(-14537 -1198)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M11.646.354a.5.5,0,0,1,.707,0L23.146,11.146a.5.5,0,0,1-.354.854H1.207a.5.5,0,0,1-.354-.854Z",
    transform: "translate(-14534 -1189)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sortAsc.1ab0a1ee18a86a129124b65bdbd7f321.svg";
export { ForwardRef as ReactComponent };